/**
 * Canonical Datadog `service` tag per build target.
 *
 * Shared by the runtime RUM/Logs init (tracing.ts, reading `isTauri()`) and the
 * build-time source-map upload (scripts/postbuild-service.ts, reading the raw
 * `NEXT_PUBLIC_IS_TAURI` env var in Node before `next build` output ships).
 * Datadog Error Tracking resolves uploaded source maps by (service, version),
 * so the two call sites must never disagree on these strings — which is why
 * there is a single source of truth here rather than two hardcoded literals.
 */
export const DATADOG_SERVICE_DESKTOP = 'scribe-desktop-app';
export const DATADOG_SERVICE_WEB = 'scribe-fe';
